/**
 * Extract a user-friendly error message from an axios error response.
 *
 * Backend subscription-blocked responses (403) carry pt-BR messages:
 *   { error_code, message, error, details, upgrade_url }
 *
 * Generic axios errors fall back to `data.message`, then `data.error`,
 * then the provided default.
 */
export const extractApiErrorMessage = (err, fallback = "Algo deu errado, tente novamente.") => {
  const data = err?.response?.data;
  if (!data) return fallback;
  if (typeof data === "string") return data;
  return data.message || data.error || data.detail || fallback;
};

/**
 * Returns true if the axios error is a subscription block (limit reached or
 * feature not available).
 */
export const isSubscriptionError = (err) => {
  const code = err?.response?.data?.error_code;
  return (
    code === "subscription_limit_reached" ||
    code === "subscription_feature_unavailable" ||
    code === "subscription_inactive"
  );
};
